document.addEventListener("DOMContentLoaded", () => {
  const builder = document.querySelector(".bundle-builder");
  const items = builder.querySelectorAll(".bundle--item");
  const addBtn = builder.querySelector(".bundle-add");
  const checkoutBtn = builder.querySelector(".bundle-checkout");
  const slotsContainer = builder.querySelector(".bundle--slots");
  const variants = builder.querySelectorAll(".variant--option");
  const purchaseTypes = builder.querySelectorAll(".purchase-type > div");
  const giftProductEl = document.querySelector(
    ".gift-item__with-product[data-gift-id]",
  );

  const GIFT_VARIANT_ID = Number(giftProductEl?.dataset.giftId || 0);
  const HAS_GIFT_PRODUCT = GIFT_VARIANT_ID > 0;

  let stockLocked = false; // 🔒 hard lock when OOS

  let selectedQty = 3; // default
  let selectedVariants = []; // track variants placed in slots
  let purchaseType = "subscription"; // default
  let sellingPlanId =
    builder.querySelector(".subscription-type").dataset.sellingId;

  /* =========================================================
   🧠 INVENTORY STOCK WATCHER (SHOPIFY SAFE)
   ========================================================= */

  // Check single variant stock
  async function isVariantInStock(variantId) {
    if (inventoryCache.has(variantId)) {
      return inventoryCache.get(variantId);
    }

    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const variant = await res.json();
      inventoryCache.set(variantId, variant.available === true);
      return variant.available === true;
    } catch (err) {
      console.warn("Stock check failed:", variantId);
      inventoryCache.set(variantId, false);
      return false;
    }
  }

  // Disable both buttons (Add + Checkout)
  function disableBundleButtons(text = "Out of Stock") {
    stockLocked = true; // 🔒 LOCK IT

    [addBtn, checkoutBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = true;
      btn.classList.add("disabled", "out-of-stock");
      btn.innerHTML = `<p>${text}</p>`;
    });
  }

  // Re-enable buttons (respects slot-fill logic)
  function enableBundleButtons() {
    if (stockLocked) return; // 🚫 DO NOTHING if locked
    updateAddButtonState();
  }

  // Check ALL selected variants stock
  async function checkBundleStock() {
    if (selectedVariants.length === 0) return;

    // Check only SELECTED variants
    const stockChecks = await Promise.all(
      selectedVariants.map((v) => isVariantInStock(v.id)),
    );

    // If ANY selected variant is out of stock → block
    if (stockChecks.includes(false)) {
      disableBundleButtons("Out of Stock");
      return;
    }

    // Otherwise allow normal bundle logic
    stockLocked = false;
    enableBundleButtons();
  }

  const inventoryCache = new Map();

  // Fetch & cache inventory for ALL variants
  async function preloadInventory() {
    const variantIds = [...variants].map((v) => Number(v.dataset.id));

    await Promise.all(
      variantIds.map(async (id) => {
        try {
          const res = await fetch(`/variants/${id}.js`);
          const variant = await res.json();
          inventoryCache.set(id, variant.available === true);
        } catch (err) {
          console.warn("Inventory preload failed:", id);
          inventoryCache.set(id, false);
        }
      }),
    );

    evaluateInitialBundleState();
  }

  // Evaluate bundle state BEFORE selection
  function evaluateInitialBundleState() {
    const availableCount = [...inventoryCache.values()].filter(Boolean).length;

    // 🚨 No stock at all
    if (availableCount === 0) {
      disableBundleButtons("Out of Stock");
      return;
    }

    enableBundleButtons();
  }

  // 🔹 Function: Create slot containers based on qty
  function createSlots(qty) {
    slotsContainer.innerHTML = "";
    selectedVariants = [];
    for (let i = 0; i < qty; i++) {
      const slot = document.createElement("div");
      slot.classList.add("bundle-slot");
      slot.dataset.index = i;
      slot.innerHTML = `<span></span>`;
      slotsContainer.appendChild(slot);
    }
    updateAddButtonState(); // disable button initially
    updateSlotCounter();
  }

  function updateAddButtonPrice() {
    if (stockLocked) return; // 🚫 HARD STOP — preserve OOS text

    const activeItem = builder.querySelector(".bundle--item.active");
    if (!activeItem) return;

    const isSubscription = purchaseType === "subscription";
    const price = isSubscription
      ? activeItem.dataset.priceSubscription
      : activeItem.dataset.priceOnetime;
    const compare = isSubscription
      ? activeItem.dataset.compareSubscription
      : activeItem.dataset.compareOnetime;

    if (addBtn) {
      addBtn.dataset.price = price;
      addBtn.dataset.compare = compare;
    }

    if (checkoutBtn) {
      checkoutBtn.dataset.price = price;
      checkoutBtn.dataset.compare = compare;
    }

    const remaining = selectedQty - selectedVariants.length;

    const addButtonText =
      remaining > 0
        ? `Choose ${remaining} More Flavor${remaining > 1 ? "s" : ""}`
        : "Add To Cart";

    const checkoutButtonText =
      remaining > 0
        ? `Choose ${remaining} More Flavor${remaining > 1 ? "s" : ""}`
        : "Checkout Now";

    const priceDisplayHTML =
      remaining === 0
        ? `
      <div class="btn--price">
        <span>${price}</span>
        ${
          compare && compare !== "null" && compare !== "undefined"
            ? `<s>${compare}</s>`
            : ""
        }
      </div>
    `
        : "";

    if (addBtn) {
      addBtn.innerHTML = `<p>${addButtonText}</p>${priceDisplayHTML}`;
    }

    if (checkoutBtn) {
      checkoutBtn.innerHTML = `<p>${checkoutButtonText}</p>${priceDisplayHTML}`;
    }
  }

  function updateSubscriptionPriceDisplay() {
    const activeItem = builder.querySelector(".bundle--item.active");
    if (!activeItem) return;

    const discountedEl = document.getElementById("bundle-discounted-price");
    const compareEl = document.getElementById("bundle-compare-price");

    const oneDiscountedEl = document.getElementById("bundle-onetime-price");
    const oneCompareEl = document.getElementById(
      "bundle-onetime-compare-price",
    );

    // 🔹 Always use subscription price & compare price
    const discounted = activeItem.dataset.priceSubscription;
    const compare = activeItem.dataset.compareSubscription;

    const oneTimePrice = activeItem.dataset.priceOnetime;
    const oneTimeCompare = activeItem.dataset.compareOnetime;

    if (discountedEl) discountedEl.textContent = discounted;
    if (compareEl) compareEl.textContent = oneTimePrice;

    if (oneDiscountedEl) oneDiscountedEl.textContent = oneTimePrice;
    if (oneCompareEl) oneCompareEl.textContent = oneTimeCompare;
  }

  function updateBundlePrices() {
    const isSubscription = purchaseType === "subscription";

    const currencyCode =
      window.Shopify?.currency?.active ||
      document.documentElement.getAttribute("data-currency") ||
      "USD";

    items.forEach((item) => {
      const qty = parseInt(item.dataset.qty, 10);
      const totalPrice = isSubscription
        ? item.dataset.priceSubscription
        : item.dataset.priceOnetime;

      let numericPrice;

      if (currencyCode === "EUR") {
        numericPrice = parseFloat(
          String(totalPrice)
            .replace(/[^\d,.-]/g, "")
            .replace(/\./g, "")
            .replace(",", "."),
        );
      } else {
        numericPrice = parseFloat(String(totalPrice).replace(/[^0-9.-]+/g, ""));
      }

      const perPackPrice = numericPrice / qty;

      let formatted;

      if (currencyCode === "EUR") {
        const numberOnly = new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(perPackPrice);

        formatted = `€${numberOnly}`;
      } else {
        formatted = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
        }).format(perPackPrice);
      }

      const span = item.querySelector("[data-pack-price]");
      if (span) span.textContent = formatted;
    });
  }

  function updateAddButtonState() {
    if (stockLocked) return; // 🚫 ABSOLUTE BLOCK

    const filled = selectedVariants.length === selectedQty;

    if (addBtn) {
      addBtn.disabled = !filled;
      addBtn.classList.toggle("disabled", !filled);
    }

    if (checkoutBtn) {
      checkoutBtn.disabled = !filled;
      checkoutBtn.classList.toggle("disabled", !filled);
    }

    updateAddButtonPrice();
  }

  async function refreshInventory() {
    stockLocked = false; // 🔓 attempt unlock
    inventoryCache.clear();
    await preloadInventory(); // re-evaluates state
  }

  // 🔴 NEW: Direct Checkout Function (for bundle-checkout button)
  async function directCheckout() {
    // 1. Inventory & Validation Check
    const stockCheck = await Promise.all(
      selectedVariants.map((v) => isVariantInStock(v.id)),
    );

    if (stockCheck.includes(false)) {
      alert("One or more items in your bundle are out of stock.");
      disableBundleButtons("Out of Stock");
      return;
    }

    if (selectedVariants.length < selectedQty) {
      alert("Please fill all slots before checking out.");
      return;
    }

    // 2. UI Feedback
    const checkoutButton = checkoutBtn;
    checkoutButton.disabled = true;
    checkoutButton.innerHTML = `<p>Processing...</p>`;

    // 3. Get FRESH Purchase Type Data (Fixing scoping)
    const activeTypeEl = builder.querySelector(".purchase-type div.active");
    const currentPurchaseType = activeTypeEl
      ? activeTypeEl.dataset.type
      : "subscription";
    const currentSellingPlanId = activeTypeEl
      ? activeTypeEl.dataset.sellingId
      : null;

    // 4. Get the same "Compare Price" the UI uses
    const activeItem = builder.querySelector(".bundle--item.active");
    const isSub = currentPurchaseType === "subscription";

    // FETCH the compare price string from your dataset
    const expectedComparePrice = isSub
      ? activeItem.dataset.compareSubscription
      : activeItem.dataset.compareOnetime;

    // 5. Build Item List
    const itemsToPost = [...selectedVariants];

    if (selectedQty >= 6 && HAS_GIFT_PRODUCT) {
      itemsToPost.push({ id: GIFT_VARIANT_ID });
    }

    // 6. Create a REAL hidden form
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/cart/add";
    form.style.display = "none";

    const redirectInput = document.createElement("input");
    redirectInput.type = "hidden";
    redirectInput.name = "return_to";
    redirectInput.value = "/checkout";
    form.appendChild(redirectInput);

    itemsToPost.forEach((item, index) => {
      // Variant ID
      const idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = `items[${index}][id]`;
      idInput.value = item.id;
      form.appendChild(idInput);

      // Quantity
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = `items[${index}][quantity]`;
      qtyInput.value = 1;
      form.appendChild(qtyInput);

      // --- NEW: FETCH AND ADD COMPARE PRICE AS PROPERTY ---
      // This ensures the "Retail" price is visible in the checkout summary
      if (item.id !== GIFT_VARIANT_ID && expectedComparePrice) {
        const propInput = document.createElement("input");
        propInput.type = "hidden";
        propInput.name = `items[${index}][properties][Original Price]`;
        propInput.value = expectedComparePrice;
        form.appendChild(propInput);
      }

      // Selling Plan
      if (
        currentPurchaseType === "subscription" &&
        currentSellingPlanId &&
        currentSellingPlanId !== "null" &&
        item.id !== GIFT_VARIANT_ID
      ) {
        const planInput = document.createElement("input");
        planInput.type = "hidden";
        planInput.name = `items[${index}][selling_plan]`;
        planInput.value = currentSellingPlanId;
        form.appendChild(planInput);
      }
    });

    // 7. Clear the cart FIRST then submit
    try {
      await fetch("/cart/clear.js", { method: "POST" });
      document.body.appendChild(form);
      form.submit();
    } catch (err) {
      console.error("Checkout failed:", err);
      window.location.href = "/checkout";
    }
  }

  function updateSlotCounter() {
    const counter = builder.querySelector(".slot-counter");
    if (!counter) return;

    const countSpan = counter.querySelector("#slot-count");
    const totalSpan = counter.querySelector("#slot-total");

    // Update count and total based on current bundle
    countSpan.textContent = selectedVariants.length;
    totalSpan.textContent = selectedQty;

    // Optional visual cue when filled
    counter.classList.toggle("filled", selectedVariants.length === selectedQty);
  }

  function autoFillSingleVariant() {
    // Only run if there is exactly one variant
    if (variants.length !== 1) return;

    const onlyVariant = variants[0];
    const variantId = onlyVariant.dataset.id;
    const variantIcon = onlyVariant.dataset.icon;

    // Clear just in case
    selectedVariants = [];

    [...slotsContainer.querySelectorAll(".bundle-slot")].forEach((slot) => {
      const index = slot.dataset.index;

      slot.classList.add("filled");
      slot.innerHTML = `
      <img src="${variantIcon}" style="width:25px;height:25px;" />
    `;

      selectedVariants.push({
        id: Number(variantId),
        icon: variantIcon,
        slot: index,
      });
    });

    updateSlotCounter();
    updateAddButtonState();
    checkBundleStock();
  }

  // Initialize slots for default (3)
  if (slotsContainer) {
    createSlots(selectedQty);
  }
  updateAddButtonPrice();
  updateBundlePrices();
  updateSubscriptionPriceDisplay();
  autoFillSingleVariant();

  // 🔹 When clicking bundle quantity (1 / 3 / 6)
  items.forEach((item) => {
    item.addEventListener("click", () => {
      items.forEach((i) => i.classList.remove("active"));
      item.classList.add("active");
      selectedQty = parseInt(item.dataset.qty);
      if (slotsContainer) {
        createSlots(selectedQty);
      }
      updateAddButtonPrice();
      updateBundlePrices();
      updateSubscriptionPriceDisplay();
      updateSlotCounter(); // ✅ update counter display
      updateGiftUnlocks(selectedQty);
      autoFillSingleVariant();
    });
  });
  updateGiftUnlocks(selectedQty);
  // 🔹 Unlock / Lock Free Gift indicators
  // Robust gift unlock toggler
  function updateGiftUnlocks(qty) {
    const giftSection = document.querySelector(".free--gift");
    if (!giftSection) return;

    const giftItems = giftSection.querySelectorAll(".gift--item");

    giftItems.forEach((giftItem) => {
      const textEl = giftItem.querySelector("p");
      const img = giftItem.querySelector("img");

      // Save original label once
      if (!giftItem.dataset.originalLabel) {
        giftItem.dataset.originalLabel = textEl.innerHTML.trim();
      }

      // Parse threshold (e.g., 3 or 6)
      let threshold = giftItem.dataset.threshold
        ? Number(giftItem.dataset.threshold)
        : (() => {
            const m = giftItem.dataset.originalLabel.match(/(\d+)/);
            return m ? Number(m[1]) : null;
          })();

      // Reset to locked state
      giftItem.classList.remove("unlocked");
      textEl.innerHTML = giftItem.dataset.originalLabel;

      // Restore locked image
      if (img && giftItem.dataset.imgLocked) {
        img.src = giftItem.dataset.imgLocked;
      }

      // Unlock condition
      if (threshold && qty >= threshold) {
        giftItem.classList.add("unlocked");

        // Change text
        const unlockedText =
          giftItem.dataset.unlockedText ||
          (threshold >= 6 ? "Free Gift" : "Free, Fast<br>Shipping");
        textEl.innerHTML = unlockedText;

        // Change image
        if (img && giftItem.dataset.imgUnlocked) {
          img.src = giftItem.dataset.imgUnlocked;
        }
      }
    });
  }

  // 🔹 When clicking purchase type (Subscribe / One-Time)
  purchaseTypes.forEach((type) => {
    type.addEventListener("click", () => {
      purchaseTypes.forEach((t) => t.classList.remove("active"));
      type.classList.add("active");
      type.classList.add("container-active");
      purchaseType = type.dataset.type;

      sellingPlanId =
        purchaseType === "subscription" ? type.dataset.sellingId : null;

      updateAddButtonPrice();
      updateBundlePrices();
      updateSubscriptionPriceDisplay();
    });
  });

  // 🔹 When clicking a variant option
  variants.forEach((variantEl) => {
    variantEl.addEventListener("click", () => {
      const variantId = variantEl.dataset.id;
      const variantIcon = variantEl.dataset.icon; // get icon URL

      // Skip if already selected or all slots full
      if (selectedVariants.length >= selectedQty)
        return console.log("All slots filled!");
      if (selectedVariants.find((v) => v.id === variantId))
        return console.log("Variant already selected!");

      // Find next empty slot
      const emptySlot = [
        ...slotsContainer.querySelectorAll(".bundle-slot"),
      ].find((s) => !s.classList.contains("filled"));
      if (!emptySlot) return;

      // Fill slot with icon instead of title
      emptySlot.classList.add("filled");
      emptySlot.innerHTML = `
      <img src="${variantIcon}" alt="Variant icon" style="width:25px;height:25px;"/>
      <button class="remove-btn" title="Remove">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.9974 18.3327C14.5998 18.3327 18.3307 14.6017 18.3307 9.99935C18.3307 5.39698 14.5998 1.66602 9.9974 1.66602C5.39502 1.66602 1.66406 5.39698 1.66406 9.99935C1.66406 14.6017 5.39502 18.3327 9.9974 18.3327Z" fill="black"/>
        <path d="M12.5 7.5L7.5 12.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.5 7.5L12.5 12.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>
    `;
      selectedVariants.push({
        id: Number(variantId),
        icon: variantIcon,
        slot: emptySlot.dataset.index,
      });
      updateSlotCounter();

      // Attach remove listener
      emptySlot.querySelector(".remove-btn").addEventListener("click", (e) => {
        e.stopPropagation();
        removeSlot(emptySlot);
      });

      updateAddButtonState();
      checkBundleStock(); // 🔴 INVENTORY CHECK
    });
  });

  // 🔹 Remove variant from a slot
  function removeSlot(slot) {
    const index = parseInt(slot.dataset.index);
    selectedVariants = selectedVariants.filter((v) => v.slot != index);
    slot.classList.remove("filled");
    slot.innerHTML = `<span></span>`;
    updateAddButtonState();
    updateSlotCounter();
    checkBundleStock(); // 🔴 INVENTORY CHECK
  }

  // 🔹 Add to cart all selected variants
  if (addBtn) {
    addBtn.addEventListener("click", () => {
      if (selectedVariants.length < selectedQty)
        return alert("Please fill all slots before adding to cart.");

      addBtn.disabled = true;
      addBtn.innerHTML = `<p>Adding...</p>`;

      const items = selectedVariants.map((v) => {
        const item = { id: v.id, quantity: 1 };
        if (purchaseType === "subscription" && sellingPlanId) {
          item.selling_plan = Number(sellingPlanId);
        }
        return item;
      });
      let cartWasEmpty = false;

      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (cart.item_count === 0) cartWasEmpty = true;
        })
        .then(() => {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items }),
          });
        })
        .then((res) => res.json())
        .then(async () => {
          if (typeof reloadDrawer === "function") await reloadDrawer();
          if (cartWasEmpty) {
            const drawer = document.querySelector("cart-drawer");
            if (drawer && drawer.open) drawer.open();
          }
          return "DONE";
        })
        .then(() => {
          // Feedback State
          addBtn.innerHTML = "<p>Added ✓</p>";

          setTimeout(() => {
            // 1. Reset selection data
            if (slotsContainer) {
              createSlots(selectedQty);
            }

            // 2. Try to auto-fill if only 1 flavor exists
            autoFillSingleVariant();

            // 3. Update the "Choose X More" text
            updateAddButtonPrice();

            // 4. FIX: Use logic to set disabled state instead of forcing it to 'false'
            updateAddButtonState();
          }, 1500);

          checkGiftInCart();
        })
        .catch((err) => {
          console.error("Add to cart failed:", err);
          addBtn.textContent = "Error";
          updateAddButtonState(); // Reset state on error
        });
    });
  }

  // ✅ Checkout button listener
  if (checkoutBtn) {
    console.log("✅ Checkout button found, adding listener");
    checkoutBtn.addEventListener("click", () => {
      console.log("🖱️ Checkout button clicked!");
      directCheckout();
    });
  }

  // 🟩 Gift Logic with Live Cart Listener
  let cartCheckInterval;
  let isGiftProcessing = false;

  // Check cart status and update gift
  async function checkGiftInCart() {
    if (!HAS_GIFT_PRODUCT) return;
    if (isGiftProcessing) return;

    isGiftProcessing = true;

    let cartModified = false; // 👈 New flag to track changes

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const totalBundleQty = cart.items.reduce((sum, item) => {
        if (item.id === GIFT_VARIANT_ID) return sum;
        return sum + item.quantity;
      }, 0);

      const giftItem = cart.items.find((item) => item.id === GIFT_VARIANT_ID);
      const hasGift = !!giftItem;

      // 🎁 ADD GIFT
      if (totalBundleQty >= 6 && !hasGift) {
        console.log("🎁 Adding gift...");
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
          }),
        });
        cartModified = true; // Cart was modified
      }

      // 🧹 REMOVE GIFT
      if (totalBundleQty < 6 && giftItem) {
        console.log("🧹 Removing gift...");
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0,
          }),
        });
        cartModified = true; // Cart was modified
      }
    } catch (err) {
      console.error("Gift check failed:", err);
    }

    isGiftProcessing = false; // RELEASE LOCK

    // 💥 NEW: If the gift logic modified the cart, reload the drawer to show the change.
    if (cartModified && typeof reloadDrawer === "function") {
      console.log("Reloading drawer after gift modification...");
      await reloadDrawer();
    }
  }
  // 🛡️ Checkout Guard — Prevent cheating during delay
  async function checkoutGuard(e) {
    if (!HAS_GIFT_PRODUCT) return;
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const totalBundleQty = cart.items.reduce((sum, item) => {
        if (item.id === GIFT_VARIANT_ID) return sum; // skip gift
        return sum + item.quantity;
      }, 0);

      const hasGift = cart.items.some((item) => item.id === GIFT_VARIANT_ID);

      // If gift exists but requirement not met (less than 6)
      if (hasGift && totalBundleQty < 6) {
        e.preventDefault();
        alert(
          "⚠️ The free gift has been removed because your total is below 6 items.",
        );

        // Remove the gift instantly
        const giftItem = cart.items.find((item) => item.id === GIFT_VARIANT_ID);
        if (giftItem) {
          await fetch(`/cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: giftItem.key,
              quantity: 0,
            }),
          });
        }

        // Re-run gift check to update UI/cart drawer
        checkGiftInCart();

        return false;
      }
    } catch (err) {
      console.error("Checkout guard error:", err);
    }
  }

  // Attach listener to all checkout buttons dynamically
  function setupCheckoutGuard() {
    document
      .querySelectorAll('[name="checkout"], .checkout, .cart__checkout')
      .forEach((btn) => {
        btn.addEventListener("click", checkoutGuard, { capture: true });
      });
  }

  // Watch for new checkout buttons (if using AJAX cart drawer)
  const checkoutObserver = new MutationObserver(setupCheckoutGuard);
  checkoutObserver.observe(document.body, { childList: true, subtree: true });

  // Initial setup
  setupCheckoutGuard();

  // 🟩 Monitor for cart changes automatically
  function startCartWatcher() {
    let lastCartState = null;

    async function checkLoop() {
      try {
        const res = await fetch("/cart.js");
        const cart = await res.json();
        const newState = JSON.stringify(
          cart.items.map((i) => ({ id: i.id, qty: i.quantity })),
        );

        if (newState !== lastCartState) {
          lastCartState = newState;
          // Cart changed → recheck gift logic
          checkGiftInCart();
        }
      } catch (err) {
        console.warn("Cart watcher error:", err);
      }
    }

    // Check every 3 seconds (safe and light)
    cartCheckInterval = setInterval(checkLoop, 3000);
  }

  // Start the watcher when the page loads
  startCartWatcher();

  // Also check gift after adding bundle
  document.addEventListener("cart:updated", checkGiftInCart);

  preloadInventory();
});
